// src/composables/useChartData.js
import axios from 'axios'
import decryptData from '@/store/auth/decryptData' // adjust to your path

const useChartData = async (officeId, setData, setLoading) => {
  try {
    const res = await axios.get(`/load-analysis?office_id=${officeId}`)
    const data = decryptData(res.data.payload).data?.analysis
    setData(data)
    setLoading(false)
  } catch (error) {
    setLoading(false)
  } finally {
    setLoading(false)
  }
}

export default useChartData
